<template>
    <div class="container-fluid">
        <Breadcrumb title="Add PMTA Config" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit Pmta Config#' + id" v-bind:button-show="false" v-show="id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <PmtaConfigForm :id="id" @hidePreloader="hidePreloader"></PmtaConfigForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import PmtaConfigForm from './forms/PmtaConfigForm';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'PmtaConfig',
        props: ['id'],
        components: {
            Preloader, PmtaConfigForm, Breadcrumb
        },
        data() {
            return {
                loading: false,
            }
        },
        mounted() {
            if (this.id) {
                this.loading = true;
            }
        },
        computed: {
        },
        methods: {
            hidePreloader(value) {
                this.loading = value
            },
        }
    }
</script>

<style scoped>
</style>
